/**
 * S5 — bilingual master names. A master record carries `name` (the primary,
 * English/display fallback every rule and refusal reads) and an OPTIONAL
 * Arabic twin `nameAr`. An Arabic screen shows the twin when it is filled in
 * and falls back to `name` when it is not; an English screen always shows
 * `name`. Pass `i18n.language` (or the store's locale) as `lang`.
 */
export function localizedName(
  record: { name: string; nameAr?: string | null | undefined },
  lang: string,
): string {
  return isArabic(lang) && hasText(record.nameAr) ? record.nameAr : record.name;
}

/** The unit's abbreviation, the same way: `symbolAr ?? symbol` on an Arabic screen. */
export function localizedSymbol(
  record: { symbol: string; symbolAr?: string | null | undefined },
  lang: string,
): string {
  return isArabic(lang) && hasText(record.symbolAr) ? record.symbolAr : record.symbol;
}

function isArabic(lang: string): boolean {
  return lang === 'ar' || lang.startsWith('ar-');
}

function hasText(value: string | null | undefined): value is string {
  return typeof value === 'string' && value.trim() !== '';
}
